import { matchPath, useLocation } from "react-router-dom";
import { Box, List } from "@mui/material";

import NavItem from "components/layouts/adminLayout/NavItem";

export default function SidebarItems({ sidebarData, ...other }) {
  const { pathname } = useLocation();

  const match = (path) => (path ? !!matchPath({ path, end: false }, pathname) : false);

  return (
    <Box {...other}>
      <List disablePadding sx={{ p: 1 }}>
        {sidebarData.map((item) => (
          <NavItem key={item.title} item={item} active={match} />
        ))}
      </List>
    </Box>
  );
}
